module.exports = __webpack_public_path__ + "static/media/9428a882-cc54-45b8-b419-09673a556f25_1.d3e8865e9efdce53c0d08c6ec0948d75.66d66a9e.jpeg";